export default __webpack_public_path__ + "static/media/CBC.0c350247.svg";